<script>
import { defineComponent } from "vue";
import customerOrderItem from '@/components/customer/orders/orderItem.vue';
import EmailOrderModal from '@/components/customer/orders/emailOrderModal.vue';
import ReorderModal from '@/components/customer/orders/reorderModal.vue';
import { useMeta } from 'quasar';

const metaData = {
  // sets document title
  title: 'Windy City Wire - Orders',
  // optional; sets final title as "Index Page - My Website", useful for multiple level meta
  titleTemplate: title => `${title}`,
}

export default defineComponent({
  name: "customerOrders",
  setup() {
    useMeta(metaData);
  },
  components: {
    customerOrderItem,
    EmailOrderModal,
    ReorderModal
  },
  computed: {
      accessToken() {
          return this.$store.getters['auth/accessToken'];
      },
      height() {
          return this.$store.getters['viewHeight']
      },
      emailOrder() {
          return this.$store.getters['customer/emailOrder'];
      },
      isProcessingOrder() {
          return this.$store.getters['customer/isProcessingOrder'];
      },
      orders() {
        return this.$store.getters['customer/orders']
      }
  },
  methods: {
      fetchShipTos() {
          this.$store.dispatch('customer/getShipTos', this.accessToken)
      },
      fetchOrders() {
          this.$store.dispatch('customer/getOrders', this.accessToken)
      },
  },
  mounted() {
      this.fetchOrders();
      this.fetchShipTos();
  }
});
</script>


<template>
  <div class="scroll" height="100vh">
    <q-list bordered v-if="Object.keys(orders).length">
        <q-scroll-area v-bind:style="{height: '100vh', maxWidth: '100%', paddingBottom: '50px'}" ref="scrollTarget">
            <customer-order-item :order=order orderType="open" v-for="order in orders.openorders" :key=order.orderNumber></customer-order-item>
            <customer-order-item :order=order orderType="closed" v-for="order in orders.closedorders" :key=order.orderNumber></customer-order-item>
            <div class="spacerBottom"></div>
        </q-scroll-area>
    </q-list>
    <div class="q-mt-xl text-center" v-if="Object.keys(orders).length==0&&!isProcessingOrder">
        <h6>No Orders</h6>
    </div>
    
    <q-inner-loading
    :showing="visible||isProcessingOrder"
    label="Please wait loading data..."
    label-class="text-cyan-7"
    label-style="font-size: 1.5em"
    color="cyan-7"
    />
			
    <!-- MODALS -->
    <email-order-modal :emailOrder=emailOrder></email-order-modal>
    <reorder-modal></reorder-modal>  

  </div>
</template>

